import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { IModoEntrada } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { ModoEntradaService } from "../../../services/catalogos/modo-entrada/modo-entrada.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoModoStatus } from "../../../states/admon-catalogos/selector";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";

@Component({
  selector: "app-add-modo",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./add-edit.component.html",
  styleUrl: "./add-edit.component.css",
})
export class AddModoEntradaComponent {
  @Output() mostrarBotones: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() modoEntradas: IModoEntrada[] = [];
  private store: Store<AppState> = inject(Store);
  private loadinServices = inject(LoadingService);
  admonCatModoStatus$ = this.store.pipe(select(selectCatalogoModoStatus));

  nuevo = false;
  descripcion = "";
  existe = false;
  nuevoRegistro!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modoEntradaService: ModoEntradaService
  ) {}

  ngOnInit() {
    console.log("empresas ", this.modoEntradas);
    this.init();
  }
  init() {
    this.nuevoRegistro = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });
  }
  nuevaModoEntrada() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "modosEntrada",
        mostrarEditar: false,
        mostrarNuevo: true,
        guardando: false,
      })
    );
  }

  cancelar() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "modosEntrada",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
    this.init();
  }

  guardarRegistro() {
    this.loadinServices.show();
    if (this.nuevoRegistro.valid) {
      // Aquí puedes realizar la lógica para guardar el comentario
      console.log("Comentario guardado:", this.nuevoRegistro.value.descripcion);
      this.modoEntradaService
        .guardarModo(this.nuevoRegistro.value.descripcion)
        .subscribe((data) => {
          if (!data.error) {
            this.cancelar();
          }
          this.loadinServices.hide();
        });
    }
  }

  ocultarBotones(ocultar: boolean) {
    this.mostrarBotones.emit(ocultar);
  }

  existeRegistro(control: any, currentValue: string): void {
    existeValorDuplicado(control, this.modoEntradas, currentValue);
  }
}
